import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import { type ReactNode, useCallback, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

interface TabConfig {
  label: string;
  icon: ReactNode;
  path: string;
}

const TABS: TabConfig[] = [{ label: "Profile", icon: <span>👤</span>, path: "/mobile/profile" }];

/**
 * Bottom navigation for mobile app
 * Add your routes here
 */
export function MobileBottomNav() {
  const history = useHistory();
  const location = useLocation();

  // Determine active tab from current path
  const activeTab = useMemo(() => {
    const index = TABS.findIndex((tab) => location.pathname.startsWith(tab.path));
    return index >= 0 ? index : 0;
  }, [location.pathname]);

  const [value, setValue] = useState(activeTab);

  const handleChange = useCallback(
    (_event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
      const selectedTab = TABS[newValue];
      if (selectedTab) {
        history.push(selectedTab.path);
      }
    },
    [history]
  );

  return (
    <BottomNavigation
      showLabels
      value={value}
      sx={{
        borderTop: 1,
        borderColor: "divider",
        height: 64,
      }}
      onChange={handleChange}
    >
      {TABS.map((tab) => (
        <BottomNavigationAction key={tab.path} label={tab.label} icon={tab.icon} />
      ))}
    </BottomNavigation>
  );
}
